export default "__VITE_ASSET__B1gWy6Dz__"